import { AuthProvider } from './AuthContext';
import ProtectedRoute from './ProtectedRoute';
import NotFound from './NotFound';
import TenantGate from './TenantGate';
import { useAuth } from './useAuth';
import { useTenant } from './useTenant';
import { logout as allauthLogout } from './allauth';
import { disableGoogleAutoSelect } from './useGoogleOneTap';

// Wrapper for logout that also reloads the page
export const logout = async () => {
  // EC-1: stop Google One Tap from instantly re-signing the user back in after
  // they log out (sets the `g_state` opt-out cookie on auth.<base>). Run it
  // concurrently with the session logout, but AWAIT it before navigating —
  // otherwise the page unloads before GSI sets g_state and the opt-out is lost.
  // disableGoogleAutoSelect always resolves (capped by its own timeout).
  await Promise.all([disableGoogleAutoSelect(), allauthLogout()]);
  window.location.href = '/'; // Redirect to the home page
};

export {
  AuthProvider,
  ProtectedRoute,
  NotFound,
  TenantGate,
  useAuth,
  useTenant,
};
